import { IContactViewModel } from '../../../core/models/accountModel';

/** Company admin — Platform seats page and seat management APIs. */
export function isBuyerPlatformAdmin(contact: IContactViewModel | null | undefined): boolean {
  if (!contact) {
    return false;
  }

  return contact.isBuyerPlatformUser === true
    && contact.isBuyer === true
    && contact.isAdmin === true;
}

/** Any Buyer Platform buyer — admins and seat users (Downloads & add-ins). */
export function isBuyerPlatformMember(contact: IContactViewModel | null | undefined): boolean {
  if (!contact) {
    return false;
  }

  return contact.isBuyerPlatformUser === true
    && contact.isBuyer === true;
}

/** Buyer Platform members skip the AI onboarding left-nav lock on login. */
export function shouldBypassBuyerLeftNavLock(contact: IContactViewModel | null | undefined): boolean {
  return isBuyerPlatformMember(contact);
}